export const FIXED_CATEGORIES = [
  ["good-standing", "good_standing_category", "Member in Good Standing"],
  ["not-good-standing", "not_good_standing_category", "Member Not in Good Standing"],
  ["non-member", "non_member_category", "Non-member"],
  ["student-intern", "student_category", "Student/Intern"],
];

const allowedIds = (standing, staff) => {
  if (standing === "Good Standing") { return ["good-standing"]; }
  return staff ? ["not-good-standing", "non-member", "student-intern"] : ["not-good-standing", "student-intern"];
};

export const offeredCategories = (ev) => FIXED_CATEGORIES.filter(([id, field]) => ["good-standing", "not-good-standing", "student-intern"].includes(id) && ev?.[field]?.enabled).map(([id, field, name]) => ({ id, name, fee: ev[field].fee || 0 }));

export const fixedCategoriesFor = (ev, standing, staff) => FIXED_CATEGORIES
  .filter(([id, field]) => allowedIds(standing, staff).includes(id) && ev?.[field]?.enabled)
  .map(([id, field, name]) => ({ id, name, fee: ev[field].fee || 0, good_standing_only: id === "good-standing" }));
